function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, "\n        .prefix__st0{fill:#0285bc}\n    ");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8 9.9h11.9v.9H15.9v7.1H26v.9H15.9v7.8h10.9v.9h-12V9.9zm12.9 0H29l5.6 7.8 5.7-7.8L48 0 35.3 18.5l6.6 9.1h-1.3l-6-8.3-6 8.3h-1.2l6.6-9.1-6.3-8.6zm14.6.9v-.9h13.5v.9h-6.2v16.8h-1.1V10.8h-6.2zM0 9.9h1.4l18.7 28-7.7-10.3L1.1 11.2v16.4H0V9.9z",
  className: "prefix__st0"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 46.4,
  cy: 35.8,
  r: 0.5,
  className: "prefix__st0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M47.8 34.9h.8c0 .4.3.7.7.7h.1c.5 0 .8-.3.8-.9v-3.6h.8v3.6c.1.8-.5 1.5-1.3 1.6h-.3c-.8.1-1.5-.5-1.6-1.3v-.1zM52 34.9h.8c.1.5.5.8 1.2.8s1.1-.3 1.1-.8-.3-.6-1-.8l-.7-.2c-.9-.2-1.3-.7-1.3-1.4S52.8 31 54 31c.9-.1 1.7.5 1.8 1.5H55c-.1-.5-.5-.8-1-.8-.6 0-1 .3-1 .8s.3.6.9.7l.6.1c1 .2 1.5.7 1.5 1.4 0 1-.8 1.6-2 1.6s-2-.5-2-1.4z",
  className: "prefix__st0"
});

var SvgIcoNext = function SvgIcoNext(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Warstwa_1",
    width: 55.9,
    height: 37.9,
    x: 0,
    y: 0,
    enableBackground: "new 0 0 55.9 37.9",
    viewBox: "0 0 55.9 37.9",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoNext, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_next.ed31bac1.svg";
export { ForwardRef as ReactComponent };